var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.825 10.213a8.2 8.2 0 0 1-4.773-1.526v6.986A6.33 6.33 0 0 1 9.722 22a6.3 6.3 0 0 1-3.525-1.07A6.329 6.329 0 0 1 10.59 9.405v3.499a2.895 2.895 0 1 0 2.017 2.769V2h3.445v.44q.019.198.052.393a4.79 4.79 0 0 0 4.72 3.957z"
  })));
};
export default SvgTiktok;